<ng-container *ngIf="max !== 0 && !onlyCounter">
  <app-badge
    *ngFor="let item of items.slice(0, max); trackBy: trackByTitle"
    [color]="item.color"
    [closable]="item.closable"
    (closeClicked)="closeClicked.emit(item.id)"
  >
    {{ item.text }}
  </app-badge>
</ng-container>

<app-badge color="grey" *ngIf="items.length > max" (click)="moreClicked.emit()">
  <ng-container *ngIf="!units">+</ng-container>
  {{ items.length - max }}
  <ng-container *ngIf="units">{{ units }}</ng-container>
</app-badge>
